// ============================================================
// useDashboardCharts Hook
// ============================================================

import useDashboardStore from '@/store/dashboardStore';

export function useDashboardCharts() {
  const charts = useDashboardStore((s) => s.charts);
  return { charts };
}
